import Vue from 'vue';

export default {
  // 获取媒体报道详情
  getNewsDetail(id) {
    return Vue.axios.get('/api/v1.0/system/news/detail?id=' + id);
  }
};
